import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const forWho = ['Traders de US30 y Oro que operan la sesión de New York.', 'Operadores que buscan pasar o mantener cuentas de fondeo (Prop Firms).', "Personas cansadas de 'quemar cuentas' por errores de gestión de riesgo.", 'Scalpers que necesitan velocidad de ejecución profesional en MetaTrader 5.'];
const notForWho = ["Personas que buscan un 'bot milagroso' para hacerse ricos sin aprender.", 'Traders que no respetan la gestión de riesgo mínima.', 'Quienes prefieren la suerte por encima de la estadística y las reglas.'];
export function Audience() {
  return <section className="py-24 bg-dark" data-id="element-15">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-17">
          {/* For Who */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="glass-panel p-8 rounded-sm" data-id="element-18">
            <h3 className="font-display text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-19">
              <span className="w-2 h-8 bg-bullish block box-glow" style={{
              boxShadow: '0 0 10px rgba(0,255,133,0.5)'
            }} data-id="element-20"></span>
              ESTO ES PARA TI SI...
            </h3>
            <ul className="space-y-6" data-id="element-21">
              {forWho.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-22">
                  <div className="bg-bullish/10 p-1 rounded-full shrink-0 mt-1" data-id="element-23">
                    <CheckIcon className="w-4 h-4 text-bullish" data-id="element-24" />
                  </div>
                  <span className="text-gray-300" data-id="element-25">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For Who */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="glass-panel border-danger/20 p-8 rounded-sm" data-id="element-26">
            <h3 className="font-display text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-27">
              <span className="w-2 h-8 bg-danger block box-glow-danger" data-id="element-28"></span>
              ESTO NO ES PARA TI SI...
            </h3>
            <ul className="space-y-6" data-id="element-29">
              {notForWho.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-30">
                  <div className="bg-danger/10 p-1 rounded-full shrink-0 mt-1" data-id="element-31">
                    <XIcon className="w-4 h-4 text-danger" data-id="element-32" />
                  </div>
                  <span className="text-gray-300" data-id="element-33">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}